/**
 * One label for a record's department, shared across modules.
 *
 * QA #84 asked that a HIRA with no department read "Not Specified" rather than
 * "General". QA #99 asked that a training course's department be shown on its
 * card and Read page. Both need the same fallback wording, and within a module
 * the filter predicate, the filter option list and every render site must agree
 * — change only the render sites and you get a filter entry that matches no row,
 * which is the actual trap in QA #84.
 *
 * Always the stored `department` NAME, never re-resolved from `department_id`:
 * the denormalized name is the safety net for a department that has since been
 * deleted (QA #102). The backend keeps the pair in step on write via
 * backend/utils/department_resolver.py.
 */
export const NO_DEPARTMENT_LABEL = 'Not Specified';

export const departmentLabel = (record) =>
  (record?.department || '').trim() || NO_DEPARTMENT_LABEL;
